import React, { useCallback, useEffect, useState } from 'react';
import getStockImportRuns from '../../api/cars/getStockImportRuns';
import getStockImportRun from '../../api/cars/getStockImportRun';
import getStockImportByVin from '../../api/cars/getStockImportByVin';
import Button from '../../components/Button/Button';
import formatDate from '../../utils/formatDate';
import fixDateTimezone from '../../utils/fixDateTimezone';
import styles from './stockImportHistory.module.css';

const when = (value) => (value ? formatDate(fixDateTimezone(value), true) : '');

const sourceTitle = (run) => (run?.source === 'bitrix' ? 'ÐÐ¸ÑÑÐ¸ÐºÑ' : 'Ð¤Ð°Ð¹Ð»Ñ');

/**
 * ÐÑÑÐ¾ÑÐ¸Ñ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¾Ð² ÑÑÐ¾ÐºÐ°.
 *
 * ÐÐ¾ÑÐ²Ð¸Ð»Ð°ÑÑ Ð¿Ð¾ÑÐ»Ðµ ÑÐ°Ð·Ð±Ð¾ÑÐ° ÑÐ°ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ Ñ Ð²ÑÐ³ÑÑÐ·ÐºÐ¾Ð¹: Ð¼Ð°ÑÐ¸Ð½Ñ Ð½Ðµ Ð±ÑÐ»Ð¾ Ð½Ð° Ð²Ð¸ÑÑÐ¸Ð½Ðµ, Ð°
 * Ð¾Ð±ÑÑÑÐ½Ð¸ÑÑ Ð¿Ð¾ÑÐµÐ¼Ñ Ð¾ÐºÐ°Ð·Ð°Ð»Ð¾ÑÑ Ð½ÐµÑÐµÐ¼ â ÑÐµÐ·ÑÐ»ÑÑÐ°Ñ Ð¿ÑÐ¾Ð³Ð¾Ð½Ð° Ð¶Ð¸Ð» ÑÐ¾Ð»ÑÐºÐ¾ Ð² Ð¿Ð°Ð¼ÑÑÐ¸, Ð¿Ð¾ÐºÐ°
 * Ð¾ÑÐºÑÑÑÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ°. Ð¢ÐµÐ¿ÐµÑÑ ÐºÐ°Ð¶Ð´ÑÐ¹ Ð¿ÑÐ¾Ð³Ð¾Ð½ ÑÐ¾ÑÑÐ°Ð½ÑÐµÑÑÑ, Ð¸ Ð½Ð° Ð²Ð¾Ð¿ÑÐ¾Ñ Â«Ð³Ð´Ðµ Ð¼Ð°ÑÐ¸Ð½Ð° VIN XÂ»
 * Ð¾ÑÐ²ÐµÑÐ°ÐµÑ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ VIN, Ð° Ð½Ðµ ÑÐ°ÑÐºÐ¾Ð¿ÐºÐ¸ Ð² Ð»Ð¾Ð³Ð°Ñ.
 */
const StockImportHistory = () => {
  const [runs, setRuns] = useState([]);
  const [openRun, setOpenRun] = useState(null);
  const [loading, setLoading] = useState(false);
  const [vin, setVin] = useState('');
  const [vinRows, setVinRows] = useState(null);
  const [vinLoading, setVinLoading] = useState(false);

  const loadRuns = useCallback(() => {
    setLoading(true);
    getStockImportRuns({ limit: 10 })
      .then((res) => setRuns(res?.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadRuns();
  }, [loadRuns]);

  const toggleRun = (id) => {
    if (openRun?.run?.id === id) {
      setOpenRun(null);
      return;
    }
    getStockImportRun(id)
      .then((res) => setOpenRun(res?.data || null))
      .catch(() => {});
  };

  const searchVin = () => {
    const value = vin.trim();
    if (!value) return;
    setVinLoading(true);
    getStockImportByVin(value)
      .then((res) => setVinRows(res?.data || []))
      .catch(() => setVinRows([]))
      .finally(() => setVinLoading(false));
  };

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>ÐÑÑÐ¾ÑÐ¸Ñ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¾Ð²</h3>

      <div className={styles.search}>
        <input
          className={styles.input}
          value={vin}
          placeholder="VIN â Ð¿Ð¾ÑÐµÐ¼Ñ Ð¼Ð°ÑÐ¸Ð½Ð° Ð½Ðµ Ð·Ð°ÐµÑÐ°Ð»Ð°"
          onChange={(event) => setVin(event.target.value)}
          onKeyDown={(event) => event.key === 'Enter' && searchVin()}
        />
        <Button text="ÐÑÐ¾Ð²ÐµÑÐ¸ÑÑ" onClick={searchVin} fill disabled={vinLoading} />
      </div>

      {vinRows !== null && (
        <div className={styles.vinResult}>
          {vinRows.length === 0 ? (
            // ÐÑÑÑÐ¾Ð¹ Ð¾ÑÐ²ÐµÑ â ÑÐ¾Ð¶Ðµ Ð¾ÑÐ²ÐµÑ: Ð·Ð½Ð°ÑÐ¸Ñ ÑÑÑÐ¾ÐºÐ° Ð´Ð¾ÑÐ¾Ð´Ð¸Ð»Ð° Ð´Ð¾ Ð¸Ð¼Ð¿Ð¾ÑÑÑÑÐ° Ð±ÐµÐ·
            // Ð¾ÑÐ¸Ð±Ð¾Ðº, Ð¸ Ð¿ÑÐ¸ÑÐ¸Ð½Ñ Ð½Ð°Ð´Ð¾ Ð¸ÑÐºÐ°ÑÑ Ð½Ðµ Ð² Ð¸Ð¼Ð¿Ð¾ÑÑÐµ, Ð° Ð² Ð·Ð°ÐºÐ°Ð·Ð°Ñ Ð¸Ð»Ð¸ Ð² Ð²ÑÐ³ÑÑÐ·ÐºÐµ.
            <p className={styles.muted}>
              ÐÐ¾ ÑÑÐ¾Ð¼Ñ VIN Ð¾ÑÐºÐ°Ð·Ð¾Ð² Ð¸Ð¼Ð¿Ð¾ÑÑÐ° Ð½ÐµÑ. ÐÐ¸Ð±Ð¾ Ð¼Ð°ÑÐ¸Ð½Ð° Ð·Ð°ÐµÑÐ°Ð»Ð°, Ð»Ð¸Ð±Ð¾ ÐµÑ Ð½Ðµ Ð±ÑÐ»Ð¾ Ð² Ð²ÑÐ³ÑÑÐ·ÐºÐµ.
            </p>
          ) : (
            vinRows.map(({ row, run }) => (
              <p key={row.id} className={styles.vinRow}>
                <b>{when(run?.createdAt)}</b> Â· {sourceTitle(run)} Â· {row.dcName || row.cityName || 'â'} â{' '}
                {row.reason}
              </p>
            ))
          )}
        </div>
      )}

      {loading && <p className={styles.muted}>ÐÐ°Ð³ÑÑÐ¶Ð°ÐµÐ¼â¦</p>}

      {!loading && runs.length === 0 && (
        <p className={styles.muted}>ÐÐ¼Ð¿Ð¾ÑÑÐ¾Ð² ÐµÑÑ Ð½Ðµ Ð±ÑÐ»Ð¾ â Ð»Ð¸Ð±Ð¾ Ð¾Ð½Ð¸ Ð¿ÑÐ¾ÑÐ»Ð¸ Ð´Ð¾ Ð¿Ð¾ÑÐ²Ð»ÐµÐ½Ð¸Ñ Ð¾ÑÑÑÑÐ°.</p>
      )}

      {runs.map((run) => (
        <div key={run.id} className={styles.run}>
          <div className={styles.runHead} onClick={() => toggleRun(run.id)}>
            <span className={styles.runWhen}>{when(run.createdAt)}</span>
            <span>{sourceTitle(run)}: {run.label}</span>
            <span className={styles.runStats}>
              ÑÑÑÐ¾Ðº {run.totalRows} Â· Ð·Ð°ÐµÑÐ°Ð»Ð¾ {run.imported} Â·{' '}
              <b className={run.rejected ? styles.bad : undefined}>Ð¾ÑÐºÐ»Ð¾Ð½ÐµÐ½Ð¾ {run.rejected}</b>
            </span>
          </div>

          {run.warnings && <p className={styles.warning}>{run.warnings}</p>}

          {openRun?.run?.id === run.id && (
            <div className={styles.rows}>
              {openRun.rows.length === 0 ? (
                <p className={styles.muted}>ÐÑÐµ ÑÑÑÐ¾ÐºÐ¸ Ð·Ð°ÐµÑÐ°Ð»Ð¸.</p>
              ) : (
                openRun.rows.map((row) => (
                  <p key={row.id} className={styles.row}>
                    <span className={styles.rowVin}>{row.vin || 'â Ð±ÐµÐ· VIN â'}</span>
                    <span>
                      {[row.markName, row.modelName, row.complectationName].filter(Boolean).join(' ')}
                      {row.dcName ? `, ${row.dcName}` : ''}
                    </span>
                    <span className={styles.rowReason}>{row.reason}</span>
                  </p>
                ))
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default StockImportHistory;
